<script setup lang="ts">
  import { CDN_URL } from '@/shared/constants'

  interface Props {
    discountPrice: number | string
  }

  defineProps<Props>()

  const COIN_ICON_URL = `${CDN_URL}/qatar/loyalty/images/coin_icon.svg`
</script>

<template>
  <p class="coins-discount-info">
    <span class="coins-discount-info__text">{{
      $t('select_plan.price_with_coins', { price: discountPrice })
    }}</span>
    <img :src="COIN_ICON_URL" alt="" class="coins-discount-info__coin" />
  </p>
</template>

<style scoped lang="scss">
  @import '@/shared/assets/styles/utils';

  .coins-discount-info {
    margin-block-end: 6px;
    display: flex;
    gap: 4px;
    align-items: center;

    &__text {
      @include caption-5-plus;

      color: var(--colorTxtSrfAction);
      background: linear-gradient(269.71deg, #ffb0b5 0.25%, #df7be8 37.94%, #6f72ed 80.17%);
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
  }
</style>
